import { withRegisterSubmit, useAuthentication, useAnalytics, captureObservabilityError } from '@psyomics/ui-common';
import { RegisterForm } from '@psyomics/ui-components';
import { useLayoutEffect, useEffect } from 'react';

import { getConfig } from '../config';
import { useReferralInviteQuery } from '../features/referral/hooks/use-referral-invite-query';
import { useLandingContext, useGetAuthSessionContext } from '../shared/contexts/landing-context';
import { usePatientAppBarContext } from '../shared/contexts/patient-app-bar';

import { PATIENT_REDIRECT_WHITELIST } from './redirect-whitelists';

const RegisterWithSubmit = withRegisterSubmit(RegisterForm, {
  redirectWhitelist: PATIENT_REDIRECT_WHITELIST,
});

const SelfHostedRegister = () => {
  const { patientApiUrl } = getConfig();
  const { setShowUrgentHelp } = usePatientAppBarContext();
  const getAuthSessionContext = useGetAuthSessionContext();
  const { preSignUpText, invitePublicId } = useLandingContext();
  const { authSystemId, isAuthenticated } = useAuthentication();
  const analytics = useAnalytics();
  const [invite, , error] = useReferralInviteQuery(invitePublicId);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (error) {
      captureObservabilityError(
        `Referral invite query failed for invite public id ${invitePublicId}: ${error.message}`
      );
    }
  }, [error, invitePublicId]);

  useEffect(() => {
    if (!isAuthenticated || !authSystemId) return;

    const serviceCode = invite?.referralSession?.referral?.service?.code;
    const timestamp = new Date().toISOString();

    analytics.identify({
      distinctId: authSystemId,
      propertiesToSetOnce: {
        signup_date: timestamp,
        ...(invitePublicId && { current_invite: invitePublicId }),
        ...(serviceCode && { current_service: serviceCode }),
      },
    });
  }, [isAuthenticated, authSystemId, invitePublicId, invite, analytics, error]);

  return (
    <div className="w-full flex justify-center mt-8">
      <div className="w-full max-w-[327px] mx-[24px]">
        <RegisterWithSubmit
          apiUrl={patientApiUrl}
          getAuthSessionContext={getAuthSessionContext}
          onUrgentHelpClick={() => setShowUrgentHelp(true)}
          preSignUpText={preSignUpText}
        />
      </div>
    </div>
  );
};

export { SelfHostedRegister };
